/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import BoxesRegular from './boxes-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BoxesRegular {...validProps} />;
}
SvgComponent.iconName = 'boxesRegular';

export const BoxesRegularIcon = svgIconWrapper(SvgComponent);
